import { defineMessages } from "react-intl";
import { stdnum } from "stdnum";

const AU_TAX_IDS = {
  TFN: "TFN",
  ABN_ACN: "ABN_ACN",
};

const AU_TAX_IDS_META = {
  [AU_TAX_IDS.TFN]: {
    type: AU_TAX_IDS.TFN,
    ...defineMessages({
      shortNameMessageDescriptor: {
        id: "hosting.tax_information_section.tfn_short_name",
        defaultMessage: "TFN",
      },
      nameMessageDescriptor: {
        id: "hosting.tax_information_section.tfn_name",
        defaultMessage: "Tax File Number",
      },
      fullNameMessageDescriptor: {
        id: "hosting.tax_information_section.tfn_full_name",
        defaultMessage: "Tax File Number (TFN)",
      },
    }),
    validationFn: stdnum.AU.tfn.validate,
    format: "000 000 000",
    ...defineMessages({
      formatStringMessageDescriptor: {
        id: "hosting.tax_information_section.tfn_format",
        defaultMessage: "8 or 9 digits",
      },
    }),
  },
  [AU_TAX_IDS.ABN_ACN]: {
    type: AU_TAX_IDS.ABN_ACN,
    ...defineMessages({
      shortNameMessageDescriptor: {
        id: "hosting.tax_information_section.abn_acn_short_name",
        defaultMessage: "ABN/ACN",
      },
      nameMessageDescriptor: {
        id: "hosting.tax_information_section.abn_acn_name",
        defaultMessage:
          "Australian Business Number / Australian Company Number",
      },
      fullNameMessageDescriptor: {
        id: "hosting.tax_information_section.abn_acn_full_name",
        defaultMessage:
          "Australian Business Number / Australian Company Number (ABN/ACN)",
      },
    }),
    validationFn: (value) => {
      const abn = stdnum.AU.abn.validate(value);
      const acn = stdnum.AU.acn.validate(value);
      return abn.isValid ? abn : acn;
    },
    format: "00 000 000 000 or 000 000 000",
    ...defineMessages({
      formatStringMessageDescriptor: {
        id: "hosting.tax_information_section.abn_acn_format",
        defaultMessage: "9 or 11 digits",
      },
    }),
  },
};

export { AU_TAX_IDS, AU_TAX_IDS_META };
